import React from "react";
import { PropTypes } from "prop-types";
import { observer } from "mobx-react";
import { isNil } from "lodash";
import { MrbModal } from "mrb/components/modal";
import { MrbSelect } from "mrb/components/select";
import { MrbButton } from "mrb/components/button";

function AddBetaChannelUserModalTemplate({ betaChannelViewStore, modalParams, t }) {
    const { userSelectStore, isSubmitting } = betaChannelViewStore;

    return (
        <MrbModal
            title={t("ADMINISTRATION.APP_RELEASE.BETA_CHANNEL.MODAL.TITLE")}
            modalParams={modalParams}
            t={t}
            className="modal__content modal__content--lrg"
        >
            <MrbSelect
                store={userSelectStore}
                classNameExtend="c-dropdown--dark c-dropdown--base"
                menuPosition="fixed"
                menuPortalTarget={document.body}
            />

            <div className="u-separator--primary u-separator--primary--base"></div>

            <div className="modal__footer__btn-group">
                <MrbButton
                    t={t}
                    label="ADMINISTRATION.APP_RELEASE.BETA_CHANNEL.MODAL.ADD"
                    disabled={isNil(userSelectStore.value) || isSubmitting}
                    onClick={betaChannelViewStore.addUser}
                />
                <MrbButton
                    classNameOverride="c-btn c-btn--base c-btn--ghost"
                    t={t}
                    label="ADMINISTRATION.APP_RELEASE.BETA_CHANNEL.MODAL.CANCEL"
                    onClick={modalParams.close}
                />
            </div>
        </MrbModal>
    );
}

AddBetaChannelUserModalTemplate.propTypes = {
    betaChannelViewStore: PropTypes.object.isRequired,
    modalParams: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default observer(AddBetaChannelUserModalTemplate);
